import { Component } from '@angular/core';

@Component({
  selector: 'app-hero-on-link',
  standalone: true,
  imports: [],
  templateUrl: '../../movi-link/hero-pages/hero-movi-link.component.html',
  styleUrl: './hero-on-link.component.css'
})
export class HeroOnLinkComponent {

  title = 'Onlink';
  subtitle1 = 'Atención médica';
  subtitle2 = 'en línea';
  callToAction = 'Contáctanos';
  routeImageMain = 'assets/img/onlink/heroImg.svg';

}
